import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Respuesta } from '../models';
import { NzUploadFile } from 'ng-zorro-antd/upload';
@Injectable({
  providedIn: 'root'
})
export class BeneficiariosService {


  url = environment.api;
  constructor(private http: HttpClient, private errorHandler: ErrorHandler) {}


  obtenerListadoBeneficiarios() {
    return this.http.get(`${this.url}SolicitudGestacion`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el listado de beneficiarios'));
      })
    );
  }

  insertarSolicitud( form : {}) {
    return this.http.post(`${this.url}SolicitudGestacion`, form).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error al actualizar solicitud de beneficiario:', error);
        return throwError(() => new Error('Error al actualizar la solicitud de beneficiario'));
      })
    );
  }

  /**
   * Genera parámetros HTTP dinámicamente basándose en las propiedades de un objeto
   * @param paramsObject - Objeto con las propiedades que se convertirán en parámetros
   * @returns HttpParams con los parámetros generados
   */
  private generarCabecerasDinamicas(paramsObject: any): HttpParams {
    let params = new HttpParams();
    Object.keys(paramsObject).forEach(key => {
      const value = paramsObject[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });
    
    return params;
  }

  /**
   * Actualiza una solicitud con parámetros dinámicos generados desde un objeto
   * @param paramsObj - Objeto con las propiedades que se convertirán en parámetros HTTP
   * @returns Observable con la respuesta del servidor
   */
  actualizarSolicitud(paramsObj?: {}) {
    let params = new HttpParams();
    if (paramsObj) {
      params = this.generarCabecerasDinamicas(paramsObj);
    }
    return this.http.put(`${this.url}SolicitudGestacion`, {}, { params }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al actualizar la solicitud de beneficiario'));
      })
    );
  }

  descargarArchivos( id: number, nombreArchivo: string ): Observable<Blob> {
    const params = new HttpParams()
      .set('id', id.toString())
      .set('nombre', nombreArchivo);
    return this.http.get(`${this.url}SolicitudGestacion/DescargarArchivoSolicitudGestante`, { responseType: 'blob', params }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al descargar los archivos'));
      })
    );
  }

  /**
   * Sube datos de beneficiario con archivos de soporte
   * @param fechaInicio - Fecha de inicio del beneficio
   * @param numeroFetos - Número de fetos
   * @param colaboradorEsGestante - Si el colaborador es gestante
   * @param beneficiarioId - ID del beneficiario
   * @param archivosFile - Archivos a subir
   * @returns Observable con la respuesta del servidor
   */
  subirDatos(
    fechaInicio: Date,
    numeroFetos: number,
    colaboradorEsGestante: boolean,
    beneficiarioId: number,
    archivosFile: NzUploadFile[],
    colaboradorId: number
  ): Observable<any> {
    let formData = new FormData();
    let params = new HttpParams()
      .set('FechaInicio', fechaInicio.toISOString().split('T')[0])
      .set('NumeroFetos', numeroFetos?.toString() || '')
      .set('colaboradorEsGestante', colaboradorEsGestante?.toString() || '')
      .set('ColaboradorId', colaboradorId.toString());
    if( beneficiarioId ) {
      params = params.set('BeneficiarioId', beneficiarioId.toString());
    }
    for( let file of archivosFile ){
      formData.append('DocumentosSoporte', file as unknown as File);
    }
    return this.http.post(`${this.url}SolicitudGestacion`, formData, { 
      params
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error(error?.error?.details || 'Error al subir los datos del beneficiario'));
      })
    );
  }
}
